import React from 'react';

import { Container, Dot, DotsWrapper } from './ProgressTracker.styled';

interface ProgressTrackerProps {
  step: string | null | undefined;
}

export const ProgressTracker: React.FC<ProgressTrackerProps> = ({ step }) => {
  const progressStep = getProgressStep(step);

  return (
    <Container>
      <DotsWrapper>
        <Dot $isActive={progressStep >= 1} />
        <Dot $isActive={progressStep >= 2} />
        <Dot $isActive={progressStep >= 3} />
      </DotsWrapper>
    </Container>
  );
};

const getProgressStep = (step: string | null | undefined): number => {
  switch (step) {
    case 'create_account':
    case 'location':
    case 'time':
    case 'insurance':
    case 'Choose Signup Option':
    case 'Email':
    case 'Google Attributes':
    case 'Apple Attributes':
    case 'Login':
    case 'Forgot Password':
    case 'Verification Code':
      return 2;
    case 'confirm':
      return 3;
    default:
      return 1;
  }
};
